import Footer from "../Components/Footer";
import Header from "../Components/Header";

function SchoolRules() {
    return (
        <>
            <Header />

            {/*  */}
            <section style={{animation:'fadeIn 1s ease-in-out'}}>
                <div className='container-fluid mb-3' style={{ background: '#002147' }}>
                    <div className='row'>
                        <div className='col-12'>
                            <h4 className="text-center text-uppercase py-3" style={{ color: 'white', fontSize: '20px', fontWeight: 'bold' }}>School Rules</h4>
                        </div>
                    </div>
                </div>
                <div className="school-rules-heading">
                    <h3>RULES FOR MODE OF FEE PAYMENT</h3>
                </div>
                <div className="container school-rules">
                    <div className="row">
                        <div className="col-12">
                            <div>
                                <ol>
                                    <li>Fee is payable for the full year in 3 installments using Eazypay (Net-banking/Debit
                                        Card or Credit Card) through our school website dpsjodhpur.in or Cheque / DD in
                                        favour of 'Delhi Public School Jodhpur', duly endorsed with the particulars of the
                                        students (Name, class, admission no., phone no.) on the reverse of the cheque. Fee
                                        installments are to be deposited in the month of April, July & November of the
                                        current session. Dates will be informed through fee circular. Late fee of Rs. 25.00
                                        per day will be charged for delayed payment. Parents have to ensure that fees is
                                        deposited on or before the due date without waiting for any reminder from the school
                                        else action will be taken for recovery of outstanding fees. A student is liable to
                                        be struck off the rolls if the fees for the entire session remains outstanding
                                        without justifiable reasons. The decision of the school as to justifiability for
                                        non-payment of fees shall be final and binding.</li>
                                    <li>Any cheque returned by the bank will be treated under the category of non-payment of
                                        fees. In such cases Rs.250/- will be charged against the cheque returned.</li>
                                    <li>In case of any doubt regarding the payment of dues, parents are advised to make the
                                        payments first and ask for refund later.</li>
                                    <li>Parents should kindly keep the receipts issued by the school/bank in safe custody
                                        and produce these to the school in proof of the payments made, if required.</li>
                                    <li>Parents are required to submit an application for the refund of caution money. The
                                        caution money is refundable in full only after settlement of all dues.</li>
                                    <li>No refund of caution money is made during summer and winter vacation.</li>
                                    <li>Non CTS cheques will not be accepted.</li>
                                    <li>In case of any refund or extra charges levied by the school, parents should kindly
                                        contact the school.</li>
                                    <li>All correspondence in respect of fee bill should be taken up directly with the
                                        Accounts Departments, DPS Jodhpur.</li>
                                    <li>A clear calendar month notice in writing or month's fee in lieu of notice must be
                                        given before a pupil has to be withdrawn. However, in case of a sudden transfer of
                                        government or service personnel, one calendar months’ notice can be waived by the
                                        Principal.</li>
                                    <li>Once a child has been admitted, no claim for the refund of one time charges (other
                                        than caution money) will be entertained. However, for the other fee, rule no. 10
                                        will apply.</li>
                                    <li>If the school fee dues (either previous/current session) of your ward is not
                                        remitted latest by 28th February of ongoing session, then this non-payment of fee
                                        may lead to any future inconvenience like withholding the examination result of
                                        ongoing session or exclusion of offline/online classes or may lead to cancellation
                                        of admission. Lapse of aforementioned time bracket as given in Rule no.1, will
                                        attract a penalty / fine / late fee charges.</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="school-rules-heading">
                    <h3>GENERAL SCHOOL RULES</h3>
                </div>
                <div className="container school-rules">
                    <div className="row">
                        <div className="col-12">
                            <div>
                                <ol>
                                    <li>Every student should carry his/her ALMANAC to school every day.</li>
                                    <li>Students who come to the school on their own, should reach school before the bell
                                        rings.</li>
                                    <li>The morning bell before a class or assembly is a signal for all to go to the
                                        assembly or to their respective classrooms. This should be done promptly and in
                                        silence. As soon as they are in their classes, students should get their books ready
                                        for the first period.</li>
                                    <li>Change of classrooms between periods should be done in silence and in an orderly
                                        manner.</li>
                                    <li>Students should be habitually clean and always neatly dressed. The school uniform,
                                        should be worn on all working days and for all the school functions. Students who
                                        are carelessly dressed or not in the uniforms will be sent home.</li>
                                    <li>Non Sikh boys should get their hair trimmed at regular intervals.</li>
                                    <li>Shouting or whistling is not allowed in the school building.</li>
                                    <li>It is strictly forbidden to throw anything at anyone.</li>
                                    <li>Care must be taken of all school property and no student should scratch or spoil the
                                        desks or charts or damage any school furniture; write or draw anything on the walls
                                        or in any way damage things belonging to others. Damage done even by accident should
                                        be reported at once to the class teacher or to the Principal.</li>
                                    <li>Students are not allowed to bring any sharp instrument to the school.</li>
                                    <li>No books (other than text books ), magazines or papers should be brought to the
                                        school without the permission of the Principal.</li>
                                    <li>Lending or borrowing of money and other articles is not permitted.</li>
                                    <li>The school is not responsible for goods lost. It is not advisable to bring valuable
                                        articles (like expensive watches or fountain pens) to school.</li>
                                    <li>Students who come to school in the care of servants should not leave before the
                                        servant arrives. In case of delay, they should report to the school office.</li>
                                    <li>The school reserves the right to suspend students whose progress in studies is
                                        unsatisfactory or whose conduct is harmful to other students.</li>
                                    <li>Parents and guardians must not visit their wards or teachers in the class rooms
                                        without the permission of the Principal.</li>
                                    <li>Students should get their report cards signed by their parents/guardians within two
                                        days of the receipt of the report cards.</li>
                                    <li>The name, class and section of the pupil should be clearly marked on all the
                                        belongings of the pupil. Blazers, Coats and Jerseys should also bear the names of
                                        the respective students.</li>
                                    <li>A child who fails twice in the same class will not be permitted to continue his/her
                                        studies in the school.</li>
                                    <li>Late comers, uniform defaulters and children who do not do their home work
                                        regularly, will be sent back home.</li>
                                    <li>A student who uses unfair means during tests will be marked zero in the subject and
                                        will be issued warning letter. Repetition of the same will result in dismissal of
                                        the student.</li>
                                    <li>Students are allowed to use the school telephone with the permission of the
                                        Principal or the Receptionist. They will not be allowed to answer phone calls during
                                        the class hours. However, messages will be taken and conveyed to the student.</li>
                                    <li>Office bearers will wear their respective badges daily.</li>
                                    <li>Students are not allowed to carry any electronic items (Mobiles, Ipods or Cameras)
                                        to the school.</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="school-rules-heading">
                    <h3>GENERAL LIBRARY RULES</h3>
                </div>

                <div className="container school-rules">
                    <div className="row">
                        <div className="col-12">
                            <div>
                                <p>The school library is open to all bonafide students of the school. All the classes are
                                    provided with one/two library periods per week. The students should observe the
                                    following rules:</p>
                                <ol>
                                    <li>All students must come to the library in a single line according to their roll
                                        numbers.</li>
                                    <li>They must be seated in the library according to their roll numbers marked on the
                                        chairs.</li>
                                    <li>They must maintain absolute silence in the library.</li>
                                    <li>The library has an “open access” system, i.e., the children are allowed to go
                                        directly to the shelves and take two books of their choice. They must put the books
                                        back on the same numbered shelf after reading, to maintain order and organization in
                                        the library.</li>
                                    <li>The students of classes II to XII can issue one Hindi book and one English book
                                        every fortnight for a period of one week.</li>
                                    <li>They must return their library books on the returning counter according to their
                                        roll numbers.</li>
                                    <li>No Reference Book will be issued to any student.</li>
                                    <li>Books marked, disfigured, damaged or lost will have to be replaced or paid for by
                                        the borrower.</li>
                                    <li>Students are not allowed to bring their personal books or belongings into the
                                        library.</li>
                                    <li>Each student must bring his/her almanac and pen to the library.</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="school-rules-heading">
                    <h3>RULES FOR SCHOOL TRANSPORT</h3>
                </div>

                <div className="container school-rules">
                    <div className="row">
                        <div className="col-12">
                            <div>
                                <p>Students can avail the school transport subject to the availability of seats. The routes
                                    of the school buses are drawn up and the parents should consult the school transport In
                                    charge for necessary details.</p>
                                <ol>
                                    <li>All students using the school bus are expected to be on the right side of the bus
                                        stop at least five minutes before the arrival time of the bus.
                                    </li>
                                    <li>The buses will not wait for the late comers.</li>
                                    <li>The child should stay away from the main road until the arrival of the bus.</li>
                                    <li>No student should come near the entry door of the bus until it has come to a
                                        complete halt.</li>
                                    <li>All students must occupy seats immediately after boarding their buses.</li>
                                    <li>The drivers are authorised to stop buses at the designated stops only, unless
                                        otherwise directed by the bus teacher. The list of stops is prepared keeping in view
                                        the convenience and safety of all bus commuters and is subject to change.</li>
                                    <li>When the bus is in motion, students must not move around in the bus and no part of
                                        their body should be outside the bus.</li>
                                    <li>No student is allowed to eat in the bus.</li>
                                    <li>Discarding of trash or food either inside or outside the buses is not permitted.
                                    </li>
                                    <li>Unruly behaviour and shouting is strictly prohibited. Courteous behaviour is
                                        expected at all times.</li>
                                    <li>The driver's attention must not be distracted for any reason.</li>
                                    <li>The bus teachers, and student bus monitors are responsible for maintaining
                                        discipline in the buses. Any serious offence must be reported to the Principal.</li>
                                    <li>Under no circumstances will children be allowed to board another bus to fulfil
                                        social engagements.</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="school-rules-heading">
                    <h3>RULES REGARDING ABSENCE</h3>
                </div>

                <div className="container school-rules">
                    <div className="row">
                        <div className="col-12">
                            <div>
                                <p>The parents must ensure the following:</p>
                                <ol>
                                    <li>No child should remain absent from the school without prior approval of the Class
                                        teacher/Principal.</li>
                                    <li>Students who have been sick should bring a medical certificate from their doctor on
                                        joining the school.</li>
                                    <li>Parents should send an application if the student is absent from school, stating the
                                        reason for being absent.</li>
                                    <li>No one who has been absent on the previous day will be admitted to the class without
                                        a letter from the parent, addressed to the Class teacher, stating the reason for
                                        absence. This will be the responsibility of the parent to ensure submission of the
                                        application as required.</li>
                                    <li>Leave can be granted on special grounds with the prior approval of the Principal.
                                    </li>
                                    <li>Repeated absence without leave or unexplained absence for more than six consecutive
                                        days renders the student liable to have his name struck off the rolls. Readmission
                                        may be granted on payment of fresh admission fee only.</li>
                                    <li>All students are expected to attend school on the first day after each of the
                                        vacations. Those absent will be fined R 50/- per day for the first three days.
                                        Absence for more than three days, immediately after a vacation renders the students
                                        liable to pay a fine of R 100/- day. After 6 days the name will be struck off the
                                        rolls. Readmission may be granted only on payment of fresh admission fees. (Those
                                        absent because of sickness must present a medical certificate, before they may be
                                        admitted to the class)</li>
                                    <li>It is compulsory for the students to complete 80% of their attendance in the year to
                                        make them eligible for their final examination. The percentage, however, could be
                                        relaxed on medical grounds.</li>
                                    <li>Students of class X or XII must make sure that their attendance must meet the
                                        criteria as set by CBSE for the board examinations. It will be the responsibility of
                                        the parents/students to ensure that this criteria is met, to sit in the board exams.
                                        CBSE may not allow to take board exams if he/she does not meet the required
                                        attendance.</li>
                                    <li>No child who is medically unfit will be allowed to take class tests or examinations.
                                    </li>
                                </ol>

                                <p className="fs-4" style={{ fontWeight: '500' }}>WITHDRAWALS</p>
                                <ol>
                                    <li>One clear calendar month's notice in writing or a month's fees in lieu of such
                                        notice must be given before a pupil can be withdrawn.</li>
                                    <li>Those who leave the school in May must in all cases pay the fees for the month of
                                        June.</li>
                                    <li>Transfer certificates are not issued until all dues of the school are settled.</li>
                                    <li>Students can be asked to leave the school on the following grounds.</li>
                                    <ol type="a">
                                        <li>Disciplinary</li>
                                        <li>Unsatisfactory progress in work.</li>
                                        <li>Detention or repeated detentions in a class.</li>
                                    </ol>
                                    <li>A student who fails twice in the same class will not be permitted to continue
                                        his/her studies in the school. It is always advisable to write to the school about
                                        the problems of your ward or for seeking guidance. Your letters will be replied
                                        after discussion with the concerned teachers. In case of parents wanting discussion
                                        with more than one teacher, a meeting will be arranged with the concerned teachers.
                                    </li>
                                </ol>

                                <p className="fs-4" style={{ fontWeight: '500' }}>PUNISHMENTS</p>
                                <ol type="a">
                                    <li>Yellow Card- Serious offences which reflect adversely on a student's conduct eg.
                                        breaking bounds, disobedience, telling lies, bunking school indicate the award of a
                                        yellow card which deprives the offender of availing any privileges in the school for
                                        a week. He/She is not allowed to attend any programme, picnics or outings. He/She
                                        will report to the respective supervisor during break time for detention. He/She
                                        will not be allowed to use the library or go for games during this period.</li>
                                    <li>Red Card - The issuance of three Yellow Cards in an academic year will automatically
                                        lead to the issuance of Red Card. It would be symbolic of expulsion of the offender
                                        from the school on disciplinary grounds. Harming the school property and provocation
                                        of negative acts would lead to the issuance of Red Card without any warning by
                                        Headmistress or Principal. Form of disciplinary measures : The following shall be
                                        the disciplinary measures which may be adopted by the school in dealing with all
                                        students.</li>
                                </ol>

                                <ol>
                                    <li>Detention during the break.</li>
                                    <li>Fine</li>
                                    <li>Expulsion</li>
                                    <li>Rustication</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <Footer />
        </>
    )
}

export default SchoolRules;